import React from 'react'
import { useTranslation } from 'react-i18next'
import PageWrap from '../../components/PageWrap/PageWrap'
import { FilterContextProvider } from '../../context/FilterContext'
import { TABLE_TYPES } from '../../enums/enumTableTypes'
import TableContracts from '../../tables/TableContracts/TableContracts'

const NoveVsechnaPage = () => {
  const { t } = useTranslation()

  return (
    <PageWrap
      title={t('title.vsechan_uverejneni', 'Všechna nová uveřejnění')}
      subtitle={t('title.vsechan_uverejneni_text', 'Všechny formuláře zveřejněné dnes.')}
    >
      <FilterContextProvider name={TABLE_TYPES.newAll}>
        <TableContracts />
      </FilterContextProvider>
    </PageWrap>
  )
}

export default NoveVsechnaPage
